// extracted by mini-css-extract-plugin
module.exports = {"promotion":"_4f720283bf--promotion--mRaDB","error":"_4f720283bf--error--XnIjy","container":"_4f720283bf--container--GCBE4"};